import { TFunction } from "i18next";

export function mailLink(translate: TFunction<"translation", undefined>) {
  const feedbackEmail = "vygruppen@service-now.com";
  const ccEmail = "team-brukerflater-drops@vy.no";
  const subject = encodeURIComponent(
    translate("Tilbakemelding fra Drops Dashboard"),
  );

  const body = encodeURIComponent(`
      1. ${translate("Hva har skjedd, og hva gjorde du da det skjedde?")}

      2. ${translate("Når skjedde det? Har det skjedd flere ganger?")}

      3. ${translate("Vedlegg gjerne et skjermbilde av hele skjermen (Trykk på windows knapp, shift og S)")}

      4. ${translate("Hvis aktuelt:")}
      - ${translate("Steg for å reprodusere feilen")}
      - ${translate("Har du prøvd noen steg for å løse problemet?")}
  `);

  return `mailto:${feedbackEmail}?cc=${ccEmail}&subject=${subject}&body=${body}`;
}
